export function genid(length = 5): string {
  return Math.random()
    .toString(36)
    .substring(2, 2 + length)
}
